import { effect, Injectable } from '@angular/core';
import { AnalyticsService } from 'ngx-shared-services';
import { GlobalNavService, User } from 'ngx-global-nav';
import { BehaviorSubject } from 'rxjs';

/**
 * A service to easily implement mixpanel tracking
 */
@Injectable()
export class MixPanelService {
  APPLICATION_NAME = 'PORTFOLIO_ADMIN';
  EVENTS = {
    DEEPLINK: 'Click Deeplink',
    VIEW_USER: 'View User',
  };
  isInit = false;
  userInformation$ = new BehaviorSubject<User>(null);

  constructor(private analyticsService: AnalyticsService, private globalNavService: GlobalNavService) {
    effect(() => {
      this.globalNavService.userData$.subscribe((user) => {
        if (user && !this.isInit) {
          this.userInformation$.next(user);
          this.analyticsService.init(user.user_id, this.APPLICATION_NAME);
          this.analyticsService.setPage('portfolio_view');
          this.isInit = true;
        }
      });
    });
  }

  deeplinkRegistration(field: string): void {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.DEEPLINK, {
          link_to: field,
        });
      }
    });
  }

  deeplinkProgram(field: string): void {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.DEEPLINK, {
          link_to: field,
        });
      }
    });
  }
}
